import { TFunction } from 'react-i18next';
import { red, orange, gray, green } from '@kizen/kds/Colors';
import { SMART_CONNECTOR_STATUSES } from './constants';
import { SmartConnectorStatus } from './types';

export const getIsSmartConnectorActive = ({
  status,
}: {
  status: SmartConnectorStatus;
}) => {
  return (
    [
      SMART_CONNECTOR_STATUSES.operational,
      SMART_CONNECTOR_STATUSES.need_attention,
    ] as SmartConnectorStatus[]
  ).includes(status);
};

export const getSmartConnectorStatusesConfig = (t: TFunction) => ({
  [SMART_CONNECTOR_STATUSES.setup]: {
    label: t('Setup In Progress'),
    color: gray['gray-800'],
  },
  [SMART_CONNECTOR_STATUSES.operational]: {
    label: t('Operational'),
    color: green['green-700'],
  },
  [SMART_CONNECTOR_STATUSES.need_attention]: {
    label: t('Operational (Needs Attention)'),
    color: red['red-700'],
  },
  [SMART_CONNECTOR_STATUSES.inactive]: {
    label: t('Inactive'),
    color: orange['orange-500'],
  },
});

export const downloadFile = (url: string = '', fileName: string = '') => {
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;

  a.target = '_blank';
  a.rel = 'noopener noreferrer';
  a.style.display = 'none';

  document.body.append(a);
  a.click();
  a.remove();
};
